import pages from "../data/pages";
import React, { useState, useEffect } from "react";

const NavBar = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      setScrolled(isScrolled);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-100 transition-none">
      <div className="max-w-7xl mx-auto px-6">
        <div className="w-full flex justify-between items-center">
          {/* Logo/Nom - gardant le style moderne avec nom complet */}
          <div className="flex items-center py-3 lg:py-4">
            <a
              href="#home"
              onClick={(e) => {
                e.preventDefault();
                props.setPage("home");
              }}
              className="group relative overflow-hidden flex items-center space-x-2 ui-btn"
            >
              <div className="relative">
                <div className="text-lg lg:text-xl font-bold rounded px-3 py-2 bg-white text-primary shadow-sm">
                  FL
                </div>
              </div>

              <div className="hidden lg:block">
                <div className="font-medium text-gray-800 group-hover:text-primary">
                  <div className="text-base font-semibold">Fabien Lapert</div>
                  <div className="text-xs text-gray-600">
                    Développeur Full-Stack
                  </div>
                </div>
              </div>
            </a>
          </div>

          <div className="hidden lg:flex items-center space-x-1">
            {pages.map((item) => (
              <button
                key={item.name}
                onClick={() => {
                  setIsOpen(false);
                  props.setPage(item.page);
                }}
                className={`group relative px-4 py-2 text-sm font-medium rounded transition-colors duration-200 ${
                  props.currentPage === item.page
                    ? "text-primary bg-blue-50"
                    : "text-gray-600 hover:text-primary hover:bg-gray-50"
                }`}
              >
                <span className="relative z-10">{item.name}</span>

                {/* underline supprimé pour plus de sobriété */}
              </button>
            ))}
            <a
              href="/CV_Fabien_Lapert.pdf"
              download
              rel="noopener noreferrer"
              className="ui-btn ml-4 inline-flex items-center px-4 py-2 text-sm font-medium rounded-lg bg-gradient-to-r from-primary to-blue-600 text-white shadow-sm"
              aria-label="Télécharger le CV de Fabien Lapert"
            >
              Télécharger le CV
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden">
            <button
              className="relative w-8 h-8 rounded transition-colors duration-200 bg-white hover:bg-gray-100"
              onClick={() => setIsOpen(!isOpen)}
            >
              <span className="sr-only">Menu</span>
              <div className="block w-4 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <span
                  className={`block absolute h-0.5 w-4 bg-gray-600 transform transition duration-300 ease-in-out ${
                    isOpen ? "rotate-45" : "-translate-y-1"
                  }`}
                ></span>
                <span
                  className={`block absolute h-0.5 w-4 bg-gray-600 transform transition duration-300 ease-in-out ${
                    isOpen ? "opacity-0" : ""
                  }`}
                ></span>
                <span
                  className={`block absolute h-0.5 w-4 bg-gray-600 transform transition duration-300 ease-in-out ${
                    isOpen ? "-rotate-45" : "translate-y-1"
                  }`}
                ></span>
              </div>
            </button>
          </div>
        </div>

        {/* Menu mobile moderne */}
        {isOpen && (
          <div className="lg:hidden absolute top-full left-0 w-full bg-white border-b border-gray-200 z-[100]">
            <div className="flex flex-col py-4 px-6 space-y-2">
              {pages.map((item) => (
                <button
                  key={item.name}
                  onClick={() => {
                    setIsOpen(false);
                    props.setPage(item.page);
                  }}
                  className={`text-left px-4 py-3 text-base font-medium transition-all duration-300 rounded-lg ui-btn ${
                    props.currentPage === item.page
                      ? "text-primary bg-blue-50"
                      : "text-gray-700 hover:text-primary hover:bg-gray-50"
                  }`}
                >
                  {item.name}
                </button>
              ))}

              <a
                href="/CV_Fabien_Lapert.pdf"
                download
                rel="noopener noreferrer"
                className="block mt-2 px-4 py-3 text-base font-medium rounded-lg bg-gradient-to-r from-primary to-blue-600 text-white text-center"
                aria-label="Télécharger le CV de Fabien Lapert"
              >
                Télécharger le CV
              </a>

              {/* Notice mobile */}
              <div className="mt-4 px-4 py-3 bg-blue-50 border border-blue-200 rounded-lg">
                <p className="text-sm text-blue-700 font-medium">
                  💡 Pour une expérience optimale, utilisez un ordinateur
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default NavBar;
